import { getBrowserRuntime, hasBrowserDocument } from '../browser-runtime';

export function deleteCookie(name: string, path = '/') {
  const documentRef = getBrowserRuntime().document;
  if (!hasBrowserDocument() || !documentRef) {
    return;
  }

  documentRef.cookie = name + `=; Max-Age=-1; path=${path}`;
}
